import { render, staticRenderFns } from "./CoreDialog.vue?vue&type=template&id=ca5bf336&scoped=true&"
import script from "./CoreDialog.vue?vue&type=script&lang=js&"
export * from "./CoreDialog.vue?vue&type=script&lang=js&"
import style0 from "./CoreDialog.vue?vue&type=style&index=0&id=ca5bf336&prod&lang=css&"
import style1 from "./CoreDialog.vue?vue&type=style&index=1&id=ca5bf336&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5bf336",
  null
  
)

export default component.exports